const INSTALLED_APPS_KEY = '@next-qr:mini-app-store:installed_apps';

export interface InstalledApp {
  app_id: string;
  name: string;
  description: string | null;
  icon: string | null;
  version: string;
  installed_at: string;
}

export function getInstalledApps(): InstalledApp[] {
  const raw = localStorage.getItem(INSTALLED_APPS_KEY);
  if (!raw) return [];
  return JSON.parse(raw);
}

export function isInstalled(appId: string): boolean {
  return getInstalledApps().some(a => a.app_id === appId);
}

export function installApp(app: {
  app_id: string;
  name: string;
  description?: string | null;
  icon?: string | null;
  version: string;
}): void {
  const apps = getInstalledApps();
  const existing = apps.findIndex(a => a.app_id === app.app_id);

  const entry: InstalledApp = {
    app_id: app.app_id,
    name: app.name,
    description: app.description ?? null,
    icon: app.icon ?? null,
    version: app.version,
    installed_at: new Date().toISOString(),
  };

  if (existing >= 0) {
    apps[existing] = entry;
  } else {
    apps.push(entry);
  }

  localStorage.setItem(INSTALLED_APPS_KEY, JSON.stringify(apps));
}

export function uninstallApp(appId: string): void {
  const apps = getInstalledApps().filter(a => a.app_id !== appId);
  localStorage.setItem(INSTALLED_APPS_KEY, JSON.stringify(apps));
}
